// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"457":"95eace30","495":"d46c2ce0","540":"a6c3cb75","931":"5f875944","962":"193a2e7f"}[chunkId] + ".chunk.js";
};